import React, { Fragment } from 'react';
import Header from '../header';
import './container.scss';
import NavbarMobile from '../navbar.mobile';

const Container = ({ className, children, popups = <Fragment/>, clear = false, testLoadDeals }) => {
  
  return (

    <Fragment>

      { popups }    

      <div className={`container container__${className}`}>

        <Header testLoadDeals = { testLoadDeals } />

        { children }

        { !clear && <NavbarMobile /> }

      </div>

    </Fragment>    

  );

}

export default Container;